import { render, staticRenderFns } from "./SubscriptionConfig.vue?vue&type=template&id=35f242d2&scoped=true"
import script from "./SubscriptionConfig.vue?vue&type=script&lang=js"
export * from "./SubscriptionConfig.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionConfig.vue?vue&type=style&index=0&id=35f242d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f242d2",
  null
  
)

export default component.exports